import React, { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '../../context/authContext';
import Navbar from '../navbar/Navbar';

const MainPrevencion = ({M}) => {
   const [modalPreLogin, setModalPreLogin] = useState("");
   const { isAuthenticated } = useAuthContext();
   
   if (!isAuthenticated) {
      return <Navigate to={"/prevencion/login"} />;
   } else {
      return (
         <>
            <Navbar  M={M} setModalPreLogin={setModalPreLogin}/>
            <Outlet />
         </>
      );
   }
}

export default MainPrevencion;